










import { Component, Vue } from 'vue-property-decorator';
import StoryComponent from '@/components/StoryComponent.vue'; // @ is an alias to /src
import { Story, statusType, privacyType } from '../Story'
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
@Component({
  name: 'Story',
  components: { StoryComponent }
})
export default class StoryView extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public storyId: string = null
  public story: Story = null
  public autoPlay: boolean = false

  public get loading(): boolean { return this.$store.state.loading }
  public get isAuthenticated(): boolean { return this.$store.getters.isAuthenticated }

  // public functions available to the html template

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    // @ts-ignore: because segment analytics is loaded in head script
    window.analytics.page(this.$options.name)

    // get story id from URL
    this.storyId = this.$route.params.id

    // no need to make API call if the actual story object was passed to us
    // comment this out because i'd rather refresh the story anyway when going here (but this DOES work if commented back in)
    // this.story = (this.$route.params.story as any)

    this.autoPlay = this.$route.params.autoPlay === 'true'
  }


}

